module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-900italic.woff2?f3c803b2d12574ab2cb68f2969e03a65";